// extracted by mini-css-extract-plugin
module.exports = {"padding_correction":"verpanding_padding_correction__3kkJM","modal_button":"verpanding_modal_button__1imH8"};